import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOrder } from "src/api/wallplast";

import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";
import { Black, Primary, White } from "src/styles/color";
import { hexToRgba } from "src/common/color";
import { convertIntToCurrency } from "src/common";
const drawerWidth = 260;

const Main = muiStyled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 60px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

const DrawerHeader = muiStyled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

const Label = styled.div`
  align-items: center;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 30px;
  color: #252525;
  position: relative;
  padding-left: 15px;
  margin-bottom: 50px;

  ::before {
    content: "";
    width: 3px;
    height: 100%;
    background-color: ${Primary};
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
    margin-right: 5px;
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: ${({ margin }) => (margin ? margin : "20px 0")};
  justify-content: ${({ justifyContent }) => justifyContent};
  position: relative;
`;

const Topic = styled.span`
  font-size: 1rem;
  color: #252525;
  font-weight: 500;
`;

const Desc = styled.span`
  font-size: 1rem;
  color: #252525;
  font-weight: 300;
  margin-left: 5px;
`;

const WallPreview = styled.div`
  width: 80%;
  padding-top: 40%;
  position: relative;
  margin: 50px auto;
  border-radius: 24px;
  border: 1px solid lightgray;
`;

const ImgPreview = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
`;

const TopicPrice = styled.span`
  font-size: ${({ grandTotal }) => (grandTotal ? "1.5rem" : "1.2rem")};
  color: ${({ grandTotal }) => (grandTotal ? Primary : "#252525")};
  font-weight: 500;
  font-family: "Prompt";
`;

const Price = styled.span`
  font-size: ${({ grandTotal }) => (grandTotal ? "1.5rem" : "1.2rem")};
  color: ${({ grandTotal }) => (grandTotal ? Primary : "#252525")};
  font-weight: 500;
  margin-left: 10px;
  font-family: "Prompt";
`;

const UnderLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: lightgray;
  margin: 10px 0;
`;

const WallplastDetail = ({ open }) => {
  let { id } = useParams();
  const [info, setInfo] = useState({});

  const fetchOrder = async () => {
    if (!!id) {
      const { data } = await getOrder(id);
      setInfo(data);
    }
  };

  useEffect(() => {
    fetchOrder()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Main open={open}>
      <DrawerHeader />

      <Container>
        <Label>Wallplast Order</Label>

        <Row>
          <Topic>Reference Code :</Topic>
          <Desc>{info?.ref_code}</Desc>
        </Row>

        <Row>
          <Topic>Theme :</Topic>
          <Desc>{info?.name}</Desc>
        </Row>

        <Row>
          <Topic>Customer :</Topic>
          <Desc>{`${info?.info_user?.first_name} ${info?.info_user?.last_name} | ${info?.info_user?.address} | ${info?.info_user?.tel} | ${info?.info_user?.email}`}</Desc>
        </Row>

        <Row>
          <Topic>Sale Code :</Topic>
          <Desc>{info?.sale_code}</Desc>
        </Row>

        <WallPreview>
          <ImgPreview
            src={info?.img?.replace("xsurface.com", "xsurface.com/2400x1500/")}
          />
        </WallPreview>

        <Row>
          <Topic>Wall : </Topic>
          <Desc>{info?.name}</Desc>

          <Row margin="5px 0">
            <Topic>Size : </Topic>
            <Desc>{`${info?.height} x ${info?.width} centimeter`}</Desc>
          </Row>

          <Row margin="5px 0">
            <Topic>Amount of space : </Topic>
            <Desc>{`${((info?.height / 100) * (info?.width / 100)).toFixed(
              2
            )} centimeter`}</Desc>
          </Row>
        </Row>

        <UnderLine />

        {!!info?.products && info?.products.length > 0 && (
          <>
            <Row>
              <Topic>Pattern 1 : </Topic>
              <Desc>{`${info?.products[0]?.product?.product_choice?.product?.item_name} | ${info?.products[0]?.product?.product_choice?.product?.item_code}`}</Desc>

              <Row margin="5px 0">
                <Topic>Size : </Topic>
                <Desc>{`${
                  info?.products[0]?.product?.size * 100
                } x 120 centimeter`}</Desc>
              </Row>

              <Row margin="5px 0">
                <Topic>Quantity : </Topic>
                <Desc>{`${info?.products[0]?.sum} plate`}</Desc>
              </Row>
            </Row>

            <UnderLine />
          </>
        )}

        {!!info?.products && info?.products.length > 1 && (
          <>
            <Row>
              <Topic>Pattern 2 : </Topic>
              <Desc>{`${info?.products[1]?.product?.product_choice?.product?.item_name} | ${info?.products[0]?.product?.product_choice?.product?.item_code}`}</Desc>

              <Row margin="5px 0">
                <Topic>Size : </Topic>
                <Desc>{`${
                  info?.products[1]?.product?.size * 100
                } x 120 centimeter`}</Desc>
              </Row>

              <Row margin="5px 0">
                <Topic>Quantity : </Topic>
                <Desc>{`${info?.products[1]?.sum} plate`}</Desc>
              </Row>
            </Row>

            <UnderLine />
          </>
        )}

        {!!info?.finishs && info?.finishs.length > 0 && (
          <>
            <Row>
              <Topic>Accessories 1 : </Topic>
              <Desc>{`${info?.finishs[0]?.finish?.name}`}</Desc>

              <Row margin="5px 0">
                <Topic>Type : </Topic>
                <Desc>
                  {info?.finishs[0]?.finish?.type === "s"
                    ? "Silicone"
                    : "Aluminum"}
                </Desc>
              </Row>

              <Row margin="5px 0">
                <Topic>Quantity : </Topic>
                <Desc>{`${info?.finishs[0]?.long} metre`}</Desc>
              </Row>
            </Row>

            <UnderLine />
          </>
        )}

        {!!info?.finishs && info?.finishs.length > 1 && (
          <>
            <Row>
              <Topic>Accessories 2 : </Topic>
              <Desc>{`${info?.finishs[1]?.finish?.name}`}</Desc>

              <Row margin="5px 0">
                <Topic>Type : </Topic>
                <Desc>
                  {info?.finishs[1]?.finish?.type === "s"
                    ? "Silicone"
                    : "Aluminum"}
                </Desc>
              </Row>

              <Row margin="5px 0">
                <Topic>Quantity : </Topic>
                <Desc>{`${info?.finishs[1]?.long} metre`}</Desc>
              </Row>
            </Row>

            <UnderLine />
          </>
        )}

        <Row justifyContent="flex-end">
          <TopicPrice>Sub Total : </TopicPrice>
          <Price>{`฿${convertIntToCurrency(
            info?.group_price?.total_price,
            false
          )}`}</Price>
        </Row>

        <Row justifyContent="flex-end">
          <TopicPrice>Vat 7% : </TopicPrice>
          <Price>{`฿${convertIntToCurrency(
            info?.group_price?.vat,
            false
          )}`}</Price>
        </Row>

        <Row justifyContent="flex-end">
          <TopicPrice>Net Price : </TopicPrice>
          <Price>{`฿${convertIntToCurrency(
            info?.group_price?.net_price,
            false
          )}`}</Price>
        </Row>

        {!!info?.discountPercent && (
          <Row justifyContent="flex-end">
            <TopicPrice>{`Discount (${info?.discountPercent}) : `}</TopicPrice>
            <Price>{`฿${convertIntToCurrency(
              (info?.group_price?.net_price *
                info?.discountPercent.split("%")[0]) /
                100,
              false
            )}`}</Price>
          </Row>
        )}

        {/* <Row justifyContent="flex-end">
        <TopicPrice>Vat : </TopicPrice>
        <Price>{`฿${convertIntToCurrency(info?.group_price?.vat)}`}</Price>
      </Row> */}

        <Row justifyContent="flex-end">
          <TopicPrice grandTotal>Grand Total : </TopicPrice>
          <Price grandTotal>
            {!!info?.discountPercent
              ? `฿${convertIntToCurrency(info?.group_price?.discount, false)}`
              : `฿${convertIntToCurrency(info?.group_price?.net_price, false)}`}
          </Price>
        </Row>
      </Container>
    </Main>
  );
};

export default WallplastDetail;
